import React, { FC, Ref } from 'react'
import InputMask from 'react-input-mask'
import cx from 'classnames'

interface IPhoneField {
  required?: boolean
  name?: string
  id: string
  register?: Ref<HTMLInputElement>
  onChange?: (...event) => void
  onBlur?: (...event) => void
  hasError?: boolean
  defaultValue?: string
}

const Phone: FC<IPhoneField> = ({
  name,
  id,
  required,
  onBlur,
  onChange,
  hasError,
  defaultValue = '',
}) => {
  return (
    <InputMask
      mask={'+7(999)-999-99-99'}
      maskChar=""
      name={name}
      onChange={onChange}
      onBlur={onBlur}
      defaultValue={defaultValue}
    >
      {() => (
        <input
          id={id}
          required={required}
          type="text"
          className={cx('input', hasError && 'error')}
        />
      )}
    </InputMask>
  )
}

export default Phone
